module.exports = __webpack_public_path__ + "img/89_beatles.14836870.jpg";